import React from "react";
import { createRoot } from "react-dom/client";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import App from "./App";
import ErrorBoundary from "../src/components/error/ErrorBoundary";
import { ThemeProvider, StyledEngineProvider } from "@mui/material";
import { verbalTheme } from "../src/components/layout/themes/verbal.theme";
import CssBaseline from "@mui/material/CssBaseline";

BigInt.prototype.toJSON = function () {
    return this.toString();
};

// Create Emotion cache with prepend option for correct CSS injection order
const cache = createCache({
    key: "css",
    prepend: true,
});

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
    <CacheProvider value={cache}>
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={verbalTheme}>
                <CssBaseline />
                <ErrorBoundary>
                    <App />
                </ErrorBoundary>
            </ThemeProvider>
        </StyledEngineProvider>
    </CacheProvider>,
);
